import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves.CumulativeDryMassRetainedPercent`]: 'Cumulative Mass Retained',

      [`cwdChart.XAxisMin`]: 'Moisture Content Start',
      [`cwdChart.XAxisMajorStep`]: 'Moisture Content Division Size',
      [`cwdChart.YAxisToXAxisStepRatio`]: 'Estimated Dry Density to Moisture Content Ratio',

      [`mddChart.XAxisMin`]: 'Moisture Content Start',
      [`mddChart.XAxisMajorStep`]: 'Moisture Content Division Size',
      [`mddChart.YAxisToXAxisStepRatio`]: 'Dry Density to Moisture Content Ratio',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves.CumulativeDryMassRetainedPercent`]: '%',

      [`cwdChart.XAxisMin`]: '%',
      [`cwdChart.XAxisMajorStep`]: '%',

      [`mddChart.XAxisMin`]: '%',
      [`mddChart.XAxisMajorStep`]: '%',
    })
  );

export default getLabelConfig;
